// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 fill=%27%236b7280%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  max-width: 800px;
  margin: auto;
  color: var(--text-100);
  min-height: 100vh;
  font-family: system-ui, sans-serif;
  padding-bottom: 80px;
}

.settings-header {
  margin: 10px;
}

.settings-header h2 {
  color: var(--primary-100);
  margin-top: 20px;
}

.settings-header p {
  color: var(--text-200);
  margin-bottom: 20px;
}

.settings-card {
  background: var(--bg-100);
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
}

.settings-card h3 {
  margin-bottom: 12px;
  color: var(--primary-200);
}

.settings-card label {
  font-size: 0.85rem;
  color: var(--text-200);
}

.settings-card input,
.settings-card textarea {
  width: 100%;
  padding: 10px;
  margin: 6px 0 12px;
  border-radius: 10px;
  border: 1px solid var(--accent-100);
  background: white;
  font-size: 16px;
}

.settings-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.success-msg {
  color: green;
  font-size: 0.85rem;
}

.photo-preview {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 10px;
  background: var(--bg-200);
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-placeholder {
  font-size: 0.75rem;
  color: var(--text-200);
}

.settings-hint {
  font-size: 0.85rem;
  color: var(--text-200);
  margin-bottom: 10px;
}

.highlight-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.highlight-input input {
  flex: 1 1;
  font-size: 16px;
}

.highlights-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.highlight-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--bg-300);
  color: var(--text-100);
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

.highlight-chip svg {
  cursor: pointer;
  font-size: 0.7rem;
}

.btn.icon {
  background: var(--primary-100);
  color: white;
  border-radius: 50%;
  padding: 10px;
}

.role-selector {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.role-btn {
  border: 1px solid var(--accent-100);
  background: white;
  color: var(--text-100);
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8rem;
}

.role-btn.active {
  background: var(--primary-100);
  color: white;
}

.profile-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.settings-card h4 {
  margin-top: 16px;
  margin-bottom: 8px;
  color: var(--primary-200);
}



.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--bg-100);
  cursor: pointer;
  transition: background 0.2s ease;
  margin-bottom: 10px;
}

.toggle-row:hover {
  background: var(--bg-300);
}

.toggle-row span {
  color: var(--text-100);
  font-size: 0.95rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 26px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: var(--accent-100);
  transition: 0.3s;
  border-radius: 26px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.switch input:checked+.slider {
  background-color: var(--primary-100);
}

.switch input:checked+.slider:before {
  transform: translateX(20px);
}



.dropdown {
  position: relative;
  margin-bottom: 12px;
}

.dropdown-header {
  background: white;
  border: 1px solid var(--accent-100);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.dropdown-header span {
  color: var(--text-100);
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  background: white;
  border-radius: 12px;
  margin-top: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.dropdown-item {
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: var(--bg-300);
}

.arrow {
  color: var(--text-200);
}

.highlight-add-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: var(--primary-100);
  color: white;
  font-size: 1.3rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease;
}

.highlight-add-btn:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.highlight-add-btn:disabled {
  background: var(--accent-100);
  cursor: not-allowed;
  transform: none;
  opacity: 0.6;
}

.highlight-limit-msg {
  font-size: 0.85rem;
  color: var(--primary-100);
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.photo-wow-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.photo-wow {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--primary-200);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  object-fit: cover;
}


.photo-wow img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.25s ease;
}

.photo-wow img.hidden {
  opacity: 0;
}

.photo-wow svg {
  font-size: 2rem;
  color: var(--text-200);
}

.photo-skeleton {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: linear-gradient(100deg,
      #f0f0f0 30%,
      #e6e6e6 50%,
      #f0f0f0 70%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  z-index: 1;
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

.photo-wow-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  color: white;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.photo-wow:hover .photo-wow-overlay {
  opacity: 1;
}

.skeleton {
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(100deg,
      #f0f0f0 30%,
      #e6e6e6 50%,
      #f0f0f0 70%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}




/* password style */

.pwd-error-message {

  margin-top: 10px;
  padding: 10px;
  border-radius: 12px;
  background: #fff1f2;
  color: #dc2626;
  font-size: 14px;

}

.pwd-success-message {

  margin-top: 10px;
  padding: 10px;
  border-radius: 12px;
  background: #f0fdf4;
  color: #16a34a;
  font-size: 14px;

}


.links-wrapper {

  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;

}

.links-wrapper input {

  flex: 1 1;
  font-size: 16px;

}

.add-link-btn {

  width: 42px;
  height: 42px;
  border: none;
  border-radius: 12px;
  background: var(--primary-100);
  color: white;
  font-size: 22px;
  cursor: pointer;
  transition: .3s;

}

.add-link-btn:hover {

  transform: scale(1.05);

}

.error-message {

  margin-top: 10px;
  font-size: 13px;
  color: #ef4444;

}


.settings-select {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e3e6ea;
  border-radius: 12px;
  background: #fff;
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  outline: none;
  transition: all 0.2s ease;
  cursor: pointer;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 18px;
}

.settings-select:hover {
  border-color: #cbd5e1;
}

.settings-select:focus {
  border-color: var(--primary-100);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.settings-select option {
  font-size: 15px;
}

/* Profile settings: CarrerUp control center. */
.settings-container {
  max-width: 1120px;
  padding: 24px 24px 56px;
  color: #1d394f;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.settings-hero {
  position: relative;
  overflow: hidden;
  margin-bottom: 18px;
  padding: 20px;
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 22px;
  background: #fbfcfd;
  box-shadow: 0 18px 40px rgba(30, 63, 88, .08), inset 0 1px #ffffff;
}

.settings-hero::before {
  content: "";
  position: absolute;
  top: 0;
  right: 34px;
  left: 34px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.settings-hero .sport-profile-topbar { width: auto; margin: 0 0 22px; }

.settings-hero .sport-back-btn {
  min-width: 0;
  padding: 9px 13px;
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 13px;
  color: #345269;
  background: #ffffff;
  box-shadow: 0 6px 15px rgba(30, 63, 88, .06);
}

.settings-hero .sport-back-btn:hover { color: #d84f0d; background: #fff8f4; transform: translateY(-1px); }

.settings-hero .back-arrow { width: 32px; height: 32px; color: #e95a13; background: #fff3ec; font-size: .95rem; }
.settings-hero .back-label { font-size: .78rem; font-weight: 800; }
.settings-hero .back-content small { color: #71899b; font-size: .65rem; opacity: 1; }

.settings-header { max-width: 650px; margin: 0; }

.settings-kicker {
  display: block;
  margin-bottom: 7px;
  color: #e95a13;
  font-size: .68rem;
  font-weight: 850;
  letter-spacing: .11em;
  text-transform: uppercase;
}

.settings-header h2 {
  margin: 0 0 7px;
  color: #1d394f;
  font-size: 1.55rem;
  font-weight: 850;
  letter-spacing: -.025em;
}

.settings-header p { margin: 0; color: #71899b; font-size: .87rem; font-weight: 500; line-height: 1.55; }

.settings-content {
  display: grid;
  grid-template-columns: minmax(280px, .7fr) minmax(0, 1.3fr);
  gap: 16px;
  align-items: start;
}

.settings-column {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 16px;
}

.settings-content .settings-card {
  position: relative;
  margin: 0;
  padding: 20px;
  overflow: hidden;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 18px;
  background: #fbfcfd;
  box-shadow: 0 12px 28px rgba(30, 63, 88, .07), inset 0 1px #ffffff;
}

.settings-content .settings-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 24px;
  left: 24px;
  height: 2px;
  background: rgba(78, 119, 153, .3);
}

.settings-content .settings-card h3 {
  margin: 2px 0 16px;
  color: #29475e;
  font-size: .98rem;
  font-weight: 850;
  letter-spacing: -.01em;
}

.settings-content .settings-card label,
.settings-content .settings-hint { color: #71899b; font-size: .73rem; font-weight: 700; letter-spacing: .01em; }

.settings-content .settings-card input,
.settings-content .settings-card textarea,
.settings-content .settings-select {
  box-sizing: border-box;
  margin: 7px 0 14px;
  padding: 12px 13px;
  border: 1px solid rgba(78, 119, 153, .2);
  border-radius: 11px;
  color: #29475e;
  background-color: #f1f5f7;
  font-family: inherit;
  font-size: .84rem;
  font-weight: 550;
  transition: .18s ease;
}

.settings-content .settings-card input:focus,
.settings-content .settings-card textarea:focus,
.settings-content .settings-select:focus {
  border-color: #e95a13;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.settings-field-error {
  margin: -7px 0 8px;
  color: #c84a37;
  font-size: .7rem;
  font-weight: 700;
}

.settings-username-rule {
  margin: -3px 0 10px;
  color: #71899b;
  font-size: .7rem;
  font-weight: 650;
  line-height: 1.45;
}

.settings-content .settings-actions { gap: 9px; margin-top: 3px; }

.settings-content .btn.primary {
  min-height: 41px;
  padding: 9px 15px;
  border: 1px solid #e95a13;
  border-radius: 11px;
  background: #e95a13;
  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);
  font-family: inherit;
  font-size: .76rem;
  font-weight: 850;
  transition: .18s ease;
}

.settings-content .btn.primary:hover { background: #d84f0d; transform: translateY(-1px); }

.settings-content .success-msg {
  padding: 6px 9px;
  border: 1px solid rgba(34, 197, 94, .2);
  border-radius: 8px;
  color: #168448;
  background: #effcf4;
  font-size: .7rem;
  font-weight: 750;
}

.photo-wow-wrapper { justify-content: flex-start; margin: 4px 0 18px; }

.settings-content .photo-wow {
  width: 126px;
  height: 126px;
  border: 2px solid #e95a13;
  border-radius: 19px;
  background: #fff3ec;
  box-shadow: 0 12px 24px rgba(233, 90, 19, .16);
}

.settings-content .photo-wow img { border-radius: 14px; }
.photo-wow-overlay { border-radius: 14px; background: rgba(29, 57, 79, .72); font-family: inherit; font-size: .74rem; font-weight: 750; }

.highlight-input,
.links-wrapper { gap: 8px; }

.highlight-add-btn,
.add-link-btn {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid #e95a13;
  border-radius: 10px;
  background: #e95a13;
  box-shadow: 0 6px 14px rgba(233, 90, 19, .16);
  font-size: 1rem;
}

.highlight-add-btn:hover,
.add-link-btn:hover { background: #d84f0d; transform: translateY(-1px); }

.highlight-chip { border: 1px solid rgba(233, 90, 19, .18); color: #a83e0d; background: #fff3ec; font-weight: 700; }
.pwd-error-message, .pwd-success-message { border-radius: 11px; font-family: inherit; font-size: .75rem; font-weight: 650; }

.settings-content .skeleton,
.settings-content .photo-skeleton { background: #eaf0f4; animation: settings-pulse 1.2s ease-in-out infinite alternate; }
@keyframes settings-pulse { from { opacity: .58; } to { opacity: 1; } }

.settings-container button:focus-visible,
.settings-container input:focus-visible,
.settings-container textarea:focus-visible,
.settings-container select:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }

@media (max-width: 768px) {
  .settings-container { padding: 0 10px 84px; }
  .settings-hero { margin: 0 -10px 14px; padding: 15px 14px 17px; border-radius: 0 0 18px 18px; }
  .settings-hero .sport-profile-topbar { margin-bottom: 16px; }
  .settings-header h2 { font-size: 1.22rem; }
  .settings-header p { font-size: .78rem; }
  .settings-content { display: flex; width: 100%; flex-direction: column; gap: 12px; }
  .settings-column { display: contents; }
  .settings-media-column .settings-card:first-child { order: 1; }
  .settings-details-column .settings-card:first-child { order: 2; }
  .settings-details-column .settings-card:last-child { order: 3; }
  .settings-media-column .settings-card:last-child { order: 4; }
  .settings-content .settings-card {
    box-sizing: border-box;
    width: 100%;
    align-self: stretch;
    padding: 15px;
    border-radius: 15px;
  }
  .settings-content .settings-card h3 { font-size: .9rem; }
  .settings-content .photo-wow { width: 104px; height: 104px; }
}


/* =========================================================
   SUBSCRIPTION SECTION
   Hérite du style général de .settings-card
========================================================= */

.subscription-card {
  position: relative;
  overflow: hidden;
}

/* Header */

.subscription-settings-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.subscription-settings-kicker {
  display: block;
  margin-bottom: 6px;

  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  opacity: 0.55;
}

.subscription-settings-top h3 {
  margin: 0 0 6px;
}

.subscription-settings-top p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  opacity: 0.7;
}


/* Badge Free / Premium */

.subscription-status-badge {
  flex-shrink: 0;

  padding: 6px 10px;
  border-radius: 999px;

  font-size: 11px;
  font-weight: 700;
}

.subscription-status-badge.free {
  background: rgba(0, 0, 0, 0.06);
}

.subscription-status-badge.premium {
  background: rgba(0, 0, 0, 0.08);
}


/* Informations abonnement */

.subscription-details {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.subscription-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  padding: 13px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);

  font-size: 13px;
}

.subscription-detail-row span {
  opacity: 0.65;
}

.subscription-detail-row strong {
  text-align: right;
  font-weight: 600;
}


/* Abonnement bientôt terminé */

.subscription-ending-message {
  margin-top: 14px;
  padding: 12px 14px;

  border-radius: 10px;
  background: rgba(0, 0, 0, 0.04);

  font-size: 12px;
  line-height: 1.5;
}


/* FREE */

.subscription-free-content {
  padding-top: 4px;
}

.subscription-benefits {
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin-bottom: 18px;
}

.subscription-benefits span {
  font-size: 13px;
  line-height: 1.4;
}


/* Boutons
   On garde volontairement une apparence proche
   des boutons existants dans Settings.
*/

.subscription-upgrade-btn,
.subscription-manage-btn {
  width: 100%;

  border: none;
  border-radius: 10px;

  padding: 11px 16px;

  font-family: inherit;
  font-size: 13px;
  font-weight: 600;

  cursor: pointer;
  transition:
    transform 0.15s ease,
    opacity 0.15s ease;
}

.subscription-upgrade-btn:hover,
.subscription-manage-btn:hover {
  transform: translateY(-1px);
}

.subscription-upgrade-btn:active,
.subscription-manage-btn:active {
  transform: translateY(0);
}

.subscription-manage-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}


/* Chargement / erreur */

.subscription-settings-loading,
.subscription-settings-error {
  font-size: 13px;
  line-height: 1.5;
}

.subscription-settings-loading {
  opacity: 0.6;
}

.subscription-settings-error {
  margin: 8px 0 0;
}


/* Mobile */

@media (max-width: 768px) {
  .subscription-settings-top {
    gap: 10px;
  }

  .subscription-detail-row {
    align-items: flex-start;
  }

  .subscription-status-badge {
    padding: 5px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentsL/ProfileSettings/ProfileSettings.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;;;AAIA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;EACvD,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB;;;kBAGgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB;;;kBAGgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;;;;AAKA,mBAAmB;;AAEnB;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;;AAEjB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;;AAEjB;;;AAGA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;;EAEE,SAAO;EACP,eAAe;;AAEjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;;AAEjB;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;;AAEhB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,eAAe;;EAEf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,yDAA+S;EAC/S,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uCAAuC,WAAW,EAAE,gBAAgB,EAAE;;AAEtE;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,uCAAuC,cAAc,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;;AAEzG,6BAA6B,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAChH,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE;AAClE,qCAAqC,cAAc,EAAE,iBAAiB,EAAE,UAAU,EAAE;;AAEpF,mBAAmB,gBAAgB,EAAE,SAAS,EAAE;;AAEhD;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB,SAAS,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAExG;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;mCACmC,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAE/G;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sCAAsC,QAAQ,EAAE,eAAe,EAAE;;AAEjE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,uCAAuC,mBAAmB,EAAE,2BAA2B,EAAE;;AAEzF;EACE,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB,2BAA2B,EAAE,kBAAkB,EAAE;;AAEtE;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,iCAAiC,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAExI;iBACiB,QAAQ,EAAE;;AAE3B;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;sBACsB,mBAAmB,EAAE,2BAA2B,EAAE;;AAExE,kBAAkB,wCAAwC,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACnH,2CAA2C,mBAAmB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAE3H;oCACoC,mBAAmB,EAAE,6DAA6D,EAAE;AACxH,4BAA4B,OAAO,YAAY,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEtE;;;2CAG2C,0BAA0B,EAAE,mBAAmB,EAAE;;AAE5F;EACE,sBAAsB,oBAAoB,EAAE;EAC5C,iBAAiB,oBAAoB,EAAE,uBAAuB,EAAE,4BAA4B,EAAE;EAC9F,uCAAuC,mBAAmB,EAAE;EAC5D,sBAAsB,kBAAkB,EAAE;EAC1C,qBAAqB,iBAAiB,EAAE;EACxC,oBAAoB,aAAa,EAAE,WAAW,EAAE,sBAAsB,EAAE,SAAS,EAAE;EACnF,mBAAmB,iBAAiB,EAAE;EACtC,oDAAoD,QAAQ,EAAE;EAC9D,sDAAsD,QAAQ,EAAE;EAChE,qDAAqD,QAAQ,EAAE;EAC/D,mDAAmD,QAAQ,EAAE;EAC7D;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;EACA,sCAAsC,gBAAgB,EAAE;EACxD,+BAA+B,YAAY,EAAE,aAAa,EAAE;AAC9D;;;AAGA;;;2DAG2D;;AAE3D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;;EAEzB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;;AAGA,yBAAyB;;AAEzB;EACE,cAAc;;EAEd,iBAAiB;EACjB,oBAAoB;;EAEpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET,eAAe;EACf,yCAAyC;;EAEzC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,mBAAmB;EACnB,+BAA+B;;EAE/B,eAAe;EACf,gBAAgB;AAClB;;;AAGA,SAAS;;AAET;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;;;CAGC;;AAED;;EAEE,WAAW;;EAEX,YAAY;EACZ,mBAAmB;;EAEnB,kBAAkB;;EAElB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;;AAGA,wBAAwB;;AAExB;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;;AAGA,WAAW;;AAEX;EACE;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".settings-container {\n  max-width: 800px;\n  margin: auto;\n  color: var(--text-100);\n  min-height: 100vh;\n  font-family: system-ui, sans-serif;\n  padding-bottom: 80px;\n}\n\n.settings-header {\n  margin: 10px;\n}\n\n.settings-header h2 {\n  color: var(--primary-100);\n  margin-top: 20px;\n}\n\n.settings-header p {\n  color: var(--text-200);\n  margin-bottom: 20px;\n}\n\n.settings-card {\n  background: var(--bg-100);\n  border-radius: 16px;\n  padding: 18px;\n  margin-bottom: 20px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);\n}\n\n.settings-card h3 {\n  margin-bottom: 12px;\n  color: var(--primary-200);\n}\n\n.settings-card label {\n  font-size: 0.85rem;\n  color: var(--text-200);\n}\n\n.settings-card input,\n.settings-card textarea {\n  width: 100%;\n  padding: 10px;\n  margin: 6px 0 12px;\n  border-radius: 10px;\n  border: 1px solid var(--accent-100);\n  background: white;\n  font-size: 16px;\n}\n\n.settings-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.success-msg {\n  color: green;\n  font-size: 0.85rem;\n}\n\n.photo-preview {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 10px;\n  background: var(--bg-200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.photo-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.photo-placeholder {\n  font-size: 0.75rem;\n  color: var(--text-200);\n}\n\n.settings-hint {\n  font-size: 0.85rem;\n  color: var(--text-200);\n  margin-bottom: 10px;\n}\n\n.highlight-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.highlight-input input {\n  flex: 1;\n  font-size: 16px;\n}\n\n.highlights-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.highlight-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg-300);\n  color: var(--text-100);\n  padding: 6px 10px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n}\n\n.highlight-chip svg {\n  cursor: pointer;\n  font-size: 0.7rem;\n}\n\n.btn.icon {\n  background: var(--primary-100);\n  color: white;\n  border-radius: 50%;\n  padding: 10px;\n}\n\n.role-selector {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.role-btn {\n  border: 1px solid var(--accent-100);\n  background: white;\n  color: var(--text-100);\n  padding: 6px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.role-btn.active {\n  background: var(--primary-100);\n  color: white;\n}\n\n.profile-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.settings-card h4 {\n  margin-top: 16px;\n  margin-bottom: 8px;\n  color: var(--primary-200);\n}\n\n\n\n.toggle-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: var(--bg-100);\n  cursor: pointer;\n  transition: background 0.2s ease;\n  margin-bottom: 10px;\n}\n\n.toggle-row:hover {\n  background: var(--bg-300);\n}\n\n.toggle-row span {\n  color: var(--text-100);\n  font-size: 0.95rem;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 46px;\n  height: 26px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: var(--accent-100);\n  transition: 0.3s;\n  border-radius: 26px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.switch input:checked+.slider {\n  background-color: var(--primary-100);\n}\n\n.switch input:checked+.slider:before {\n  transform: translateX(20px);\n}\n\n\n\n.dropdown {\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.dropdown-header {\n  background: white;\n  border: 1px solid var(--accent-100);\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dropdown-header span {\n  color: var(--text-100);\n}\n\n.dropdown-menu {\n  position: absolute;\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  margin-top: 6px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.dropdown-item {\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.dropdown-item:hover {\n  background: var(--bg-300);\n}\n\n.arrow {\n  color: var(--text-200);\n}\n\n.highlight-add-btn {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: none;\n  background: var(--primary-100);\n  color: white;\n  font-size: 1.3rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.highlight-add-btn:hover {\n  opacity: 0.9;\n  transform: scale(1.05);\n}\n\n.highlight-add-btn:disabled {\n  background: var(--accent-100);\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.6;\n}\n\n.highlight-limit-msg {\n  font-size: 0.85rem;\n  color: var(--primary-100);\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.photo-wow-wrapper {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.photo-wow {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: var(--primary-200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  object-fit: cover;\n}\n\n\n.photo-wow img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.25s ease;\n}\n\n.photo-wow img.hidden {\n  opacity: 0;\n}\n\n.photo-wow svg {\n  font-size: 2rem;\n  color: var(--text-200);\n}\n\n.photo-skeleton {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: linear-gradient(100deg,\n      #f0f0f0 30%,\n      #e6e6e6 50%,\n      #f0f0f0 70%);\n  background-size: 200% 100%;\n  animation: shimmer 1.2s infinite;\n  z-index: 1;\n}\n\n@keyframes shimmer {\n  from {\n    background-position: 200% 0;\n  }\n\n  to {\n    background-position: -200% 0;\n  }\n}\n\n.photo-wow-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  color: white;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.photo-wow:hover .photo-wow-overlay {\n  opacity: 1;\n}\n\n.skeleton {\n  width: 100%;\n  border-radius: 10px;\n  background: linear-gradient(100deg,\n      #f0f0f0 30%,\n      #e6e6e6 50%,\n      #f0f0f0 70%);\n  background-size: 200% 100%;\n  animation: shimmer 1.2s infinite;\n}\n\n@keyframes shimmer {\n  from {\n    background-position: 200% 0;\n  }\n\n  to {\n    background-position: -200% 0;\n  }\n}\n\n\n\n\n/* password style */\n\n.pwd-error-message {\n\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: #fff1f2;\n  color: #dc2626;\n  font-size: 14px;\n\n}\n\n.pwd-success-message {\n\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: #f0fdf4;\n  color: #16a34a;\n  font-size: 14px;\n\n}\n\n\n.links-wrapper {\n\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 12px;\n\n}\n\n.links-wrapper input {\n\n  flex: 1;\n  font-size: 16px;\n\n}\n\n.add-link-btn {\n\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 12px;\n  background: var(--primary-100);\n  color: white;\n  font-size: 22px;\n  cursor: pointer;\n  transition: .3s;\n\n}\n\n.add-link-btn:hover {\n\n  transform: scale(1.05);\n\n}\n\n.error-message {\n\n  margin-top: 10px;\n  font-size: 13px;\n  color: #ef4444;\n\n}\n\n\n.settings-select {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid #e3e6ea;\n  border-radius: 12px;\n  background: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  color: #1f2937;\n  outline: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='%236b7280' viewBox='0 0 20 20'%3E%3Cpath d='M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 18px;\n}\n\n.settings-select:hover {\n  border-color: #cbd5e1;\n}\n\n.settings-select:focus {\n  border-color: var(--primary-100);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.settings-select option {\n  font-size: 15px;\n}\n\n/* Profile settings: CarrerUp control center. */\n.settings-container {\n  max-width: 1120px;\n  padding: 24px 24px 56px;\n  color: #1d394f;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.settings-hero {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 18px;\n  padding: 20px;\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 22px;\n  background: #fbfcfd;\n  box-shadow: 0 18px 40px rgba(30, 63, 88, .08), inset 0 1px #ffffff;\n}\n\n.settings-hero::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 34px;\n  left: 34px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.settings-hero .sport-profile-topbar { width: auto; margin: 0 0 22px; }\n\n.settings-hero .sport-back-btn {\n  min-width: 0;\n  padding: 9px 13px;\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 13px;\n  color: #345269;\n  background: #ffffff;\n  box-shadow: 0 6px 15px rgba(30, 63, 88, .06);\n}\n\n.settings-hero .sport-back-btn:hover { color: #d84f0d; background: #fff8f4; transform: translateY(-1px); }\n\n.settings-hero .back-arrow { width: 32px; height: 32px; color: #e95a13; background: #fff3ec; font-size: .95rem; }\n.settings-hero .back-label { font-size: .78rem; font-weight: 800; }\n.settings-hero .back-content small { color: #71899b; font-size: .65rem; opacity: 1; }\n\n.settings-header { max-width: 650px; margin: 0; }\n\n.settings-kicker {\n  display: block;\n  margin-bottom: 7px;\n  color: #e95a13;\n  font-size: .68rem;\n  font-weight: 850;\n  letter-spacing: .11em;\n  text-transform: uppercase;\n}\n\n.settings-header h2 {\n  margin: 0 0 7px;\n  color: #1d394f;\n  font-size: 1.55rem;\n  font-weight: 850;\n  letter-spacing: -.025em;\n}\n\n.settings-header p { margin: 0; color: #71899b; font-size: .87rem; font-weight: 500; line-height: 1.55; }\n\n.settings-content {\n  display: grid;\n  grid-template-columns: minmax(280px, .7fr) minmax(0, 1.3fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.settings-column {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.settings-content .settings-card {\n  position: relative;\n  margin: 0;\n  padding: 20px;\n  overflow: hidden;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 18px;\n  background: #fbfcfd;\n  box-shadow: 0 12px 28px rgba(30, 63, 88, .07), inset 0 1px #ffffff;\n}\n\n.settings-content .settings-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 24px;\n  left: 24px;\n  height: 2px;\n  background: rgba(78, 119, 153, .3);\n}\n\n.settings-content .settings-card h3 {\n  margin: 2px 0 16px;\n  color: #29475e;\n  font-size: .98rem;\n  font-weight: 850;\n  letter-spacing: -.01em;\n}\n\n.settings-content .settings-card label,\n.settings-content .settings-hint { color: #71899b; font-size: .73rem; font-weight: 700; letter-spacing: .01em; }\n\n.settings-content .settings-card input,\n.settings-content .settings-card textarea,\n.settings-content .settings-select {\n  box-sizing: border-box;\n  margin: 7px 0 14px;\n  padding: 12px 13px;\n  border: 1px solid rgba(78, 119, 153, .2);\n  border-radius: 11px;\n  color: #29475e;\n  background-color: #f1f5f7;\n  font-family: inherit;\n  font-size: .84rem;\n  font-weight: 550;\n  transition: .18s ease;\n}\n\n.settings-content .settings-card input:focus,\n.settings-content .settings-card textarea:focus,\n.settings-content .settings-select:focus {\n  border-color: #e95a13;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.settings-field-error {\n  margin: -7px 0 8px;\n  color: #c84a37;\n  font-size: .7rem;\n  font-weight: 700;\n}\n\n.settings-username-rule {\n  margin: -3px 0 10px;\n  color: #71899b;\n  font-size: .7rem;\n  font-weight: 650;\n  line-height: 1.45;\n}\n\n.settings-content .settings-actions { gap: 9px; margin-top: 3px; }\n\n.settings-content .btn.primary {\n  min-height: 41px;\n  padding: 9px 15px;\n  border: 1px solid #e95a13;\n  border-radius: 11px;\n  background: #e95a13;\n  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);\n  font-family: inherit;\n  font-size: .76rem;\n  font-weight: 850;\n  transition: .18s ease;\n}\n\n.settings-content .btn.primary:hover { background: #d84f0d; transform: translateY(-1px); }\n\n.settings-content .success-msg {\n  padding: 6px 9px;\n  border: 1px solid rgba(34, 197, 94, .2);\n  border-radius: 8px;\n  color: #168448;\n  background: #effcf4;\n  font-size: .7rem;\n  font-weight: 750;\n}\n\n.photo-wow-wrapper { justify-content: flex-start; margin: 4px 0 18px; }\n\n.settings-content .photo-wow {\n  width: 126px;\n  height: 126px;\n  border: 2px solid #e95a13;\n  border-radius: 19px;\n  background: #fff3ec;\n  box-shadow: 0 12px 24px rgba(233, 90, 19, .16);\n}\n\n.settings-content .photo-wow img { border-radius: 14px; }\n.photo-wow-overlay { border-radius: 14px; background: rgba(29, 57, 79, .72); font-family: inherit; font-size: .74rem; font-weight: 750; }\n\n.highlight-input,\n.links-wrapper { gap: 8px; }\n\n.highlight-add-btn,\n.add-link-btn {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #e95a13;\n  border-radius: 10px;\n  background: #e95a13;\n  box-shadow: 0 6px 14px rgba(233, 90, 19, .16);\n  font-size: 1rem;\n}\n\n.highlight-add-btn:hover,\n.add-link-btn:hover { background: #d84f0d; transform: translateY(-1px); }\n\n.highlight-chip { border: 1px solid rgba(233, 90, 19, .18); color: #a83e0d; background: #fff3ec; font-weight: 700; }\n.pwd-error-message, .pwd-success-message { border-radius: 11px; font-family: inherit; font-size: .75rem; font-weight: 650; }\n\n.settings-content .skeleton,\n.settings-content .photo-skeleton { background: #eaf0f4; animation: settings-pulse 1.2s ease-in-out infinite alternate; }\n@keyframes settings-pulse { from { opacity: .58; } to { opacity: 1; } }\n\n.settings-container button:focus-visible,\n.settings-container input:focus-visible,\n.settings-container textarea:focus-visible,\n.settings-container select:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }\n\n@media (max-width: 768px) {\n  .settings-container { padding: 0 10px 84px; }\n  .settings-hero { margin: 0 -10px 14px; padding: 15px 14px 17px; border-radius: 0 0 18px 18px; }\n  .settings-hero .sport-profile-topbar { margin-bottom: 16px; }\n  .settings-header h2 { font-size: 1.22rem; }\n  .settings-header p { font-size: .78rem; }\n  .settings-content { display: flex; width: 100%; flex-direction: column; gap: 12px; }\n  .settings-column { display: contents; }\n  .settings-media-column .settings-card:first-child { order: 1; }\n  .settings-details-column .settings-card:first-child { order: 2; }\n  .settings-details-column .settings-card:last-child { order: 3; }\n  .settings-media-column .settings-card:last-child { order: 4; }\n  .settings-content .settings-card {\n    box-sizing: border-box;\n    width: 100%;\n    align-self: stretch;\n    padding: 15px;\n    border-radius: 15px;\n  }\n  .settings-content .settings-card h3 { font-size: .9rem; }\n  .settings-content .photo-wow { width: 104px; height: 104px; }\n}\n\n\n/* =========================================================\n   SUBSCRIPTION SECTION\n   Hérite du style général de .settings-card\n========================================================= */\n\n.subscription-card {\n  position: relative;\n  overflow: hidden;\n}\n\n/* Header */\n\n.subscription-settings-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.subscription-settings-kicker {\n  display: block;\n  margin-bottom: 6px;\n\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n\n  opacity: 0.55;\n}\n\n.subscription-settings-top h3 {\n  margin: 0 0 6px;\n}\n\n.subscription-settings-top p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  opacity: 0.7;\n}\n\n\n/* Badge Free / Premium */\n\n.subscription-status-badge {\n  flex-shrink: 0;\n\n  padding: 6px 10px;\n  border-radius: 999px;\n\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.subscription-status-badge.free {\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.subscription-status-badge.premium {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n\n/* Informations abonnement */\n\n.subscription-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.subscription-detail-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n\n  padding: 13px 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n\n  font-size: 13px;\n}\n\n.subscription-detail-row span {\n  opacity: 0.65;\n}\n\n.subscription-detail-row strong {\n  text-align: right;\n  font-weight: 600;\n}\n\n\n/* Abonnement bientôt terminé */\n\n.subscription-ending-message {\n  margin-top: 14px;\n  padding: 12px 14px;\n\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.04);\n\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n\n/* FREE */\n\n.subscription-free-content {\n  padding-top: 4px;\n}\n\n.subscription-benefits {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  margin-bottom: 18px;\n}\n\n.subscription-benefits span {\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n\n/* Boutons\n   On garde volontairement une apparence proche\n   des boutons existants dans Settings.\n*/\n\n.subscription-upgrade-btn,\n.subscription-manage-btn {\n  width: 100%;\n\n  border: none;\n  border-radius: 10px;\n\n  padding: 11px 16px;\n\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    opacity 0.15s ease;\n}\n\n.subscription-upgrade-btn:hover,\n.subscription-manage-btn:hover {\n  transform: translateY(-1px);\n}\n\n.subscription-upgrade-btn:active,\n.subscription-manage-btn:active {\n  transform: translateY(0);\n}\n\n.subscription-manage-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n\n/* Chargement / erreur */\n\n.subscription-settings-loading,\n.subscription-settings-error {\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.subscription-settings-loading {\n  opacity: 0.6;\n}\n\n.subscription-settings-error {\n  margin: 8px 0 0;\n}\n\n\n/* Mobile */\n\n@media (max-width: 768px) {\n  .subscription-settings-top {\n    gap: 10px;\n  }\n\n  .subscription-detail-row {\n    align-items: flex-start;\n  }\n\n  .subscription-status-badge {\n    padding: 5px 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
